export function formatGqlUserMessage(message: string | undefined): string {
  return `Error: ${message}`
}
